import GeoPoint from "@/models/Shared/GeoPoint";

export default class BookingLocationSummaryDto {

    brandName = '';
    department = '';
    fullAddress = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
    healthAndSafetyAssessment = '';
    locationArrivalInstructions = '';
    departmentArrivalInstructions = '';
}
